/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { useDispatch, useSelector } from 'react-redux';
import { RootReducer } from 'store/store';
import { 
  startVideochat, 
  closeVideochat, 
  toggleFloatingMode, 
  toggleMinimized, 
  hideVideochat, 
  showVideochat,
  StartVideochatPayload 
} from 'store/slices/videochat.slice';

/**
 * Custom React hook for managing videochat functionality.
 * Provides methods to start/end calls, toggle floating mode, minimize window,
 * and access videochat state from Redux store.
 * @returns Object with videochat state and control functions
 */
export const useVideochat = () => {
  const dispatch = useDispatch();
  const videochatState = useSelector((state: RootReducer) => state.videochat);

  const startCall = (payload: StartVideochatPayload) => {
    dispatch(startVideochat(payload));
  };

  const endCall = () => {
    dispatch(closeVideochat());
  };

  const toggleFloat = () => {
    dispatch(toggleFloatingMode());
  };

  const toggleMinimize = () => {
    dispatch(toggleMinimized());
  };

  const hide = () => {
    dispatch(hideVideochat());
  };

  const show = () => {
    dispatch(showVideochat());
  };

  const startFloatingCall = (appointmentId: string, patientName: string, providerName: string) => {
    startCall({
      appointmentId,
      patientName,
      providerName,
      startFloating: true
    });
  };

  return {
    isOpen: videochatState.isOpen,
    isFloating: videochatState.isFloating,
    isMinimized: videochatState.isMinimized,
    isActive: videochatState.isActive,
    callState: videochatState.callState,
    appointmentId: videochatState.appointmentId,
    patientName: videochatState.patientName,
    providerName: videochatState.providerName,
    position: videochatState.position,

    startCall,
    startFloatingCall,
    endCall,
    toggleFloat,
    toggleMinimize,
    hide,
    show,

    state: videochatState
  };
};

export default useVideochat;

